import { render, staticRenderFns } from "./WarningMess.vue?vue&type=template&id=5a336afe&"
import script from "./WarningMess.vue?vue&type=script&lang=js&"
export * from "./WarningMess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports